import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api'
import { v4 as uuidv4 } from 'uuid'

interface SnackbarItem {
  key: string
  title: string
  type: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Snackbar',
  setup(__props, { expose }) {

const list = ref<Array<SnackbarItem>>([])

const add = (type: string, title: string) => {
  const uid: string = uuidv4()
  list.value.push({ key: uid, title, type })

  setTimeout(() => {
    remove(uid)
  }, 3000)
}

const remove = (key: string) => {
  const index = list.value.findIndex((item: SnackbarItem) => item.key === key)
  if (index > -1) {
    list.value.splice(index, 1)
  }
}

expose({
  add
})

return { __sfc: true,list, add, remove }
}

})